import axios from 'axios'

export const GET_ALL_CITIES = () =>
  axios.get(`${process.env.REACT_APP_BASE_URL}/api/cities/getCities`)
